import script from "./EditKontrakPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditKontrakPage.vue?vue&type=script&setup=true&lang=js"

import "./EditKontrakPage.vue?vue&type=style&index=0&id=7c159e34&lang=css"

const __exports__ = script;

export default __exports__